import React, { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import Hero from './landing/Hero'
import Journey from './landing/Journey'
import {
    Compare, ContactSection, DownloadBanner, Faq, Features,
    Impact, Modules, StatsStrip, Testimonials, Ticker,
} from './landing/Sections'
import useLandingEffects from '../hooks/useLandingEffects'
import { useLandingRates, useLandingStats } from '../hooks/useLandingData'
import { scrollToSection } from '../hooks/useSectionNav'

const Landing = () => {
    const rootRef = useRef(null)
    const location = useLocation()
    const navigate = useNavigate()
    useLandingEffects(rootRef)
    const rates = useLandingRates()
    const stats = useLandingStats()

    // Arriving from another page via a section link (see useSectionNav).
    const targetSection = location.state?.section
    useEffect(() => {
        if (!targetSection) return
        requestAnimationFrame(() => scrollToSection(targetSection))
        navigate('/', { replace: true, state: null })
    }, [targetSection, navigate])

    return (
        <>
            <Header />
            <main ref={rootRef}>
                <Hero rates={rates} />
                <Ticker rates={rates} />
                <StatsStrip stats={stats} />
                <Modules />
                <Impact />
                <Features />
                <Journey />
                <Compare />
                <Testimonials />
                <Faq />
                <ContactSection />
                <DownloadBanner />
            </main>
            <Footer />
        </>
    )
}

export default Landing
